import { axiosInstance } from "../axios";
import {
  KeyCategory,
  KeyCategoryCreate,
  RequestResponse,
  ResourceFetchParams
} from "../types";

export const getKeyCategories: (
  params: ResourceFetchParams
) => Promise<
  RequestResponse<{ categories: KeyCategory[]; count: number }>
> = async ({ pageNumber, pageSize }) => {
  try {
    const response = await axiosInstance.get(
      `/des-key-info/get-all?page=${pageNumber}&size=${pageSize}`
    );
    return {
      error: false,
      data: {
        categories: response.data.data.content,
        count: response.data.data.count
      }
    };
  } catch (err) {
    console.error("Unable to get key categories: ", err.response?.data || err);
    return {
      error: true,
      message: err.response?.data?.responseMessage || err.message,
      data: null
    };
  }
};

export const getKeyCategoryNames: () => Promise<
  RequestResponse<string[]>
> = async () => {
  try {
    const response = await axiosInstance.get(
      "/des-key-info/get-all-categories"
    );
    return {
      error: false,
      data: response.data.data
    };
  } catch (err) {
    console.error(
      "Unable to get key category names: ",
      err.response?.data || err
    );
    return {
      error: true,
      message: err.response?.data?.responseMessage || err.message,
      data: null
    };
  }
};

export const createKeyCategory: (
  keyCategory: KeyCategoryCreate
) => Promise<RequestResponse> = async keyCategory => {
  try {
    await axiosInstance.post("/des-key-info", keyCategory);
    return {
      error: false,
      data: null
    };
  } catch (err) {
    console.error("Unable to create key category: ", err.response?.data || err);
    return {
      error: true,
      message: err.response?.data?.responseMessage || err.message,
      data: null
    };
  }
};

export const updateKeyCategory: (
  keyCategory: KeyCategory
) => Promise<RequestResponse> = async keyCategory => {
  try {
    await axiosInstance.put(
      `/des-key-info/update/${keyCategory.id}`,
      keyCategory
    );
    return {
      error: false,
      data: null
    };
  } catch (err) {
    console.error("Unable to update key category: ", err.response?.data || err);
    return {
      error: true,
      message: err.response?.data?.responseMessage || err.message,
      data: null
    };
  }
};
